import {
  LPH_ITEM_NAME,
  LPH_ITEM_PATH,
  LPH_LIST_NAME,
  LPH_LIST_PATH,
} from '~packages/epk-front-router/routes.json';

export default [
  {
    path: LPH_ITEM_PATH,
    name: LPH_ITEM_NAME,
    component: () => import('@/pages/LphItem'),
  },
  {
    path: LPH_LIST_PATH,
    name: LPH_LIST_NAME,
    component: () => import('@/pages/LphList'),
  },
];
